'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'rv';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f7be';
var svgPathData = ['M48 64l0 278.1 38.8 38.8c16.1-17.7 39.3-28.9 65.2-28.9 40.1 0 74 26.9 84.6 63.6l99.4 0 0-303.6 192 0 0-47.9c-160 0-320 0-480-.1zm48 64l160 0 0 128-160 0 0-128zM384 336l0 25.6c12-6.1 25.6-9.6 40-9.6 40.1 0 74 26.9 84.6 63.6l19.4 0 0-79.6-144 0z', 'M352 0l-160 0 0 16-192 0 0 345.9 7 7 57.9 57.9c-.6 4.3-1 8.6-1 13.1 0 48.6 39.4 88 88 88 40.3 0 74.2-27.1 84.7-64l102.6 0c10.4 36.9 44.4 64 84.7 64s74.2-27.1 84.7-64l67.3 0 0-159.3-4-6-64-96-7.1-10.7-116.8 0 0-32 192 0 0-144-224 0 0-16zM336 416l-99.3 0c-10.4-36.9-44.4-64-84.7-64-25.8 0-49.1 11.1-65.2 28.9l-38.8-38.8 0-278.1 480 0 0 48-192 0 0 304zm192 0l-19.3 0c-10.4-36.9-44.4-64-84.7-64-14.4 0-28 3.5-40 9.6l0-25.6 144 0 0 80zM384 288l0-48 91.2 0 32 48-123.2 0zm40 112a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM112 440a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM96 128l0 128 160 0 0-128-160 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRv = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;